import React from "react";
import PropTypes from "prop-types";
import { ReactComponentStaticProps } from "../../types/react";

import styles from "./ComparisonTable.scss";

type ComparisonTableColorsBaseProps = {
  colors: Array<{ color: string; isLight?: boolean | null }>;
};

export type ComparisonTableColorsProps = ComparisonTableColorsBaseProps;

export const ComparisonTableColors: ((
  props: ComparisonTableColorsProps
) => JSX.Element) &
  ReactComponentStaticProps<ComparisonTableColorsProps> = ({ colors }) => {
  return (
    <div>
      {colors.map((color) => (
        <span
          key={color.color}
          style={{
            backgroundColor: color.color,
            borderColor: color.isLight ? "#979797" : color.color,
          }}
          className={styles.color}
        />
      ))}
    </div>
  );
};

ComparisonTableColors.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      isLight: PropTypes.bool,
    }).isRequired
  ).isRequired,
};

ComparisonTableColors.displayName = "ComparisonTable.Colors";

export default ComparisonTableColors;
